import React from 'react';
import { motion } from 'motion/react';
import { cn } from '@/lib/utils';

interface Partner {
  id: string;
  name: string;
  logo?: React.ReactNode;
}

interface PartnersMarqueeProps {
  partners?: Partner[];
  speed?: number;
  className?: string;
  pauseOnHover?: boolean;
}

const defaultPartners: Partner[] = [
  { id: '1', name: 'Samsung' },
  { id: '2', name: 'LG Electronics' },
  { id: '3', name: 'SK Telecom' },
  { id: '4', name: 'Kakao' },
  { id: '5', name: 'Naver' },
  { id: '6', name: 'Coupang' },
  { id: '7', name: 'Hyundai' },
  { id: '8', name: 'Toss' },
];

export const PartnersMarquee: React.FC<PartnersMarqueeProps> = ({
  partners = defaultPartners,
  speed = 30,
  className,
  pauseOnHover = true,
}) => {
  return (
    <div className={cn("relative w-full overflow-hidden", className)}>
      {/* Gradient masks for both sides */}
      <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-1/4 bg-gradient-to-r from-background to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-1/4 bg-gradient-to-l from-background to-transparent" />
      
      <div className="relative flex gap-16">
        <MarqueeContent
          partners={partners}
          speed={speed}
          pauseOnHover={pauseOnHover}
        />
        <MarqueeContent
          partners={partners}
          speed={speed}
          pauseOnHover={pauseOnHover}
        />
      </div>
    </div>
  );
};

const MarqueeContent: React.FC<{
  partners: Partner[];
  speed: number;
  pauseOnHover: boolean;
}> = ({ partners, speed, pauseOnHover }) => {
  return (
    <motion.div
      className="flex shrink-0 items-center gap-16"
      animate={{
        x: ['0%', '-100%'],
      }}
      transition={{
        x: {
          duration: speed,
          repeat: Infinity,
          ease: 'linear',
        },
      }}
      whileHover={pauseOnHover ? { animationPlayState: 'paused' } as any : undefined}
    >
      {partners.map((partner) => (
        <div
          key={partner.id}
          className="flex shrink-0 items-center justify-center"
        >
          {partner.logo ? (
            partner.logo
          ) : (
            <div className="relative group cursor-default">
              <span className="text-lg font-semibold text-zinc-600 whitespace-nowrap px-8 transition-all duration-300 group-hover:text-zinc-400">
                {partner.name}
              </span>
              <div className="absolute inset-x-0 -bottom-1 h-[2px] bg-gradient-to-r from-transparent via-zinc-700 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
            </div>
          )}
        </div>
      ))}
    </motion.div>
  );
};

export default PartnersMarquee;